// extracted by mini-css-extract-plugin
module.exports = {"coming_soon":"style_coming_soon__7yKHb","viewAll":"style_viewAll__t03PU","icon":"style_icon__zju3V"};